import React, { Component } from 'react'
import { Link }             from 'react-router-dom'

import Meta         from './components/meta'
import Preview      from './components/preview'
import Attachments  from './components/attachments'
import Content      from './components/content'

import './css/image.css'

export default class Image extends Component {

  state = {}

  componentDidMount() {
    this.load(this.props)
  }

  componentWillReceiveProps(props) {
    this.load(props)
  }

  load(props) {
    this.setState({image: props.item})
  }

  render() {
    return !this.state.image ? '' : (
      <div className="image">
        <Meta data={this.props.data} item={this.state.image} />
        <Preview data={this.props.data} image={this.state.image} zoom={true} />
        <div className="image-title">
          <h1>
            {this.state.image.name}
            {this.state.image.date && (
              <span className="image-date">{this.state.image.date}</span>
            )}
          </h1>
        </div>
        <div className="image-data">
          {this.state.image.description && (
            <Text
              text        = {this.state.image.description}
              seriesTitle = {this.props.data.content.series_title}
              series      = {this.state.image.series} />
          )}
          {this.state.image.content && (
            <Text
              text           = {this.state.image.content}
              moreHint       = {this.props.data.content.more_hint}
              brightnessHint = {this.state.image.white && this.props.data.content.brightness_hint}
              separator      = {this.state.image.description} />
          )}
          {this.state.image.variants && this.state.image.variants.length > 0 && (
            <Images title={this.props.data.content.variants_title} images={this.state.image.variants} />
          )}
          {this.state.image.originals && this.state.image.originals.length > 0 && (
            <Images title={this.props.data.content.originals_title} images={this.state.image.originals} />
          )}
          {this.state.image.sketches && this.state.image.sketches.length > 0 && (
            <Images title={this.props.data.content.sketches_title} images={this.state.image.sketches} />
          )}
          {this.state.image.relatedWorks && this.state.image.relatedWorks.length > 0 && (
            <Images title={this.props.data.content.related_works_title} images={this.state.image.relatedWorks} />
          )}
        </div>
      </div>
    )
  }

}

function Text(props) {
  return (
    <div className={`image-text ${props.separator && 'image-separator'}`}>
      <Content text={props.text} moreHint={props.moreHint} brightnessHint={props.brightnessHint} />
      {props.series && props.series.length > 0 && (
        <div className="image-list">
          <span className="image-subheading">{props.seriesTitle}:</span>
          {props.series.map((item, n) => (
            <Link to={item.url} key={n} className="image-item">{item.name}</Link>
          ))}
        </div>
      )}
    </div>
  )
}

function Images(props) {
  return (
    <div>
      <h2 className="image-heading">{props.title}</h2>
      <Attachments attachments={props.images} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/image.js